import { useQueryClient } from '@tanstack/react-query';
export function useQueryClientState(key) {
  var queryClient = useQueryClient();
  return queryClient.getQueryState(key);
}